var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"choose-map"},[_c('iframe',{attrs:{"src":"https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=ILYBZ-7ZMK2-RPMU3-CSPUT-62L5T-LNFX5&referer=hydd"}})])
}]

export { render, staticRenderFns }